<template>
    <div class="breadcrumb">
        <ul>
            <li><a href="/">صفحه اصلی</a></li>
            <li><a href="#">{{ breadcrumbs.parentName }}</a></li>
            <li>
                <router-link :to="{ path: '/category/' + categoryName }">
                    {{ breadcrumbs.name }}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { PRODUCT_LIST_PATHS } from '@/constants/storePaths.js';

    export default {
        name: 'BreadCrumbs',
        props: {
            categoryId: Number
        },
        data() {
            return {
                categoryName: this.$route.params.id
            };
        },
        computed: {
            ...mapGetters({
                breadcrumbs: PRODUCT_LIST_PATHS.breadcrumbsGetter
            })
        },
        mounted() {
            this.fetchBreadcrumbs(this.categoryId);
        },
        methods: {
            ...mapActions({
                fetchBreadcrumbs: PRODUCT_LIST_PATHS.fetchBreadcrumbs
            })
        }
    };
</script>
